import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

function CourseDetailsDialog({ onClose, open, courseDetails }) {
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Dialog
      PaperProps={{
        sx: {
          width: 400,
          maxHeight: 400,
        },
      }}
      onClose={handleClose}
      open={open}
      fullScreen={true}
    >
      <DialogTitle>Course Details</DialogTitle>

      <DialogContent>CONTENT</DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default CourseDetailsDialog;
